import Loadable from '../../components/loadable';

const IntegrationsList = Loadable({
  loader: () => import('../../pages/integrations/integrations_list'),
});

angular.module('gym').value('IntegrationsList', IntegrationsList);
